import React, { useState, useCallback, useMemo } from 'react';
import { UserScopeContext } from '../contexts/UserScopeContext';

export const UserScopeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [globalUserId, setGlobalUserId] = useState<string | null>(null);
  const [overrideUserId, setOverrideUserId] = useState<string | null>(null);

  const effectiveUserId = overrideUserId || globalUserId;

  const clearOverrides = useCallback(() => setOverrideUserId(null), []);

  const value = useMemo(
    () => ({
      globalUserId,
      setGlobalUserId,
      overrideUserId,
      setOverrideUserId,
      effectiveUserId,
      clearOverrides,
    }),
    [globalUserId, overrideUserId, effectiveUserId, clearOverrides]
  );

  return <UserScopeContext.Provider value={value}>{children}</UserScopeContext.Provider>;
};
